// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_31-3";
export var dialog = "_31-0";
export var divClassnameSwatch = "_31-8";
export var flexSwatch = "_31-4";
export var header = "_31-1";
export var styleAttributeSwatch = "_31-7";
export var swatch = "_31-2";
export var textHeaderSwatch = "_31-5";
export var webSwatch = "_31-6";